export default {
  bankOptions: [],
  navItems: [],
  filterItems: [],
  paymentMethods: [],
  loaded: false
}
